/* eslint-disable react/jsx-props-no-spreading */
import mergeClasses from '../../../utils/shallowMerge';
import CategoryTile from '../../molecules/categoryTile';
import { Heading } from '../../typography/heading/Heading';
import { Text } from '../../typography/text/Text';
import Title from '../../typography/title';
import defaultClasses from './CategoriesGrid.module.scss';
import clsx from 'clsx';
import React from 'react';
import { StylesCustomizer } from '../../molecules/stylesCustomizer';

const CategoriesSectionGrid = ({
  categories,
  label,
  labelStyles,
  title,
  titleStyles,
  customClasses,
  customClassesForCategoryTile,
  tileLayout = 'stacked',
}) => {
  const styles = mergeClasses(defaultClasses, customClasses);
  const LabelText = (variables) => {
    return (
      <Text
        className={styles.cateogryLabel}
        as="span"
        weight="normal"
        textTransform="uppercase"
        variables={variables}
      >
        <span
          dangerouslySetInnerHTML={{
            __html: label,
          }}
        />
      </Text>
    );
  };
  const TitleText = (variables) => {
    return (
      <Heading
        align="center"
        className={styles.categoryHeader}
        as="h1"
        placement="plp"
        textTransform="uppercase"
        weight="light"
        variables={variables}
      >
        <span
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      </Heading>
    );
  };
  const StyledLabelText = StylesCustomizer(LabelText);
  const StyledTitleText = StylesCustomizer(TitleText);

  const categoriesTitle =
    label || title ? (
      <Title className={styles.categoryTitle}>
        {label && <StyledLabelText styles={labelStyles} />}
        {title && <StyledTitleText styles={titleStyles} />}
      </Title>
    ) : null;

  if (!categories || !Array.from(categories).length) return null;

  return (
    <div
      className={styles.popularCategoriesSectionGrid}
      style={{
        '--grid-count': categories.length,
      }}
    >
      {categoriesTitle}
      <div className={clsx(styles.categoriesGrid)}>
        {categories
          ? Array.from(categories).map((cat, index) => {
              const imageMd = cat.imageHeightMd || cat.imageHeightLg;
              const imageSm = cat.imageHeightsm ? cat.imageHeightsm : imageMd;
              return (
                <CategoryTile
                  style={{
                    '--image-height-lg': cat.imageHeightLg
                      ? `${cat.imageHeightLg}%`
                      : '125%',
                    '--image-height-md': imageMd ? `${imageMd}%` : '125%',
                    '--image-height-sm': imageSm ? `${imageSm}%` : '125%',
                  }}
                  key={`category_${index}`}
                  align={cat.contentAlignment}
                  titleLink={cat.categoryUrl}
                  title={cat.teaserText && cat.teaserText}
                  titleStyles={cat.titleStyles}
                  description={cat.teaserDescription}
                  descriptionStyles={cat.descriptionStyles}
                  image={cat.categoryImage}
                  links={cat.subcats && cat.subcats}
                  isFeatured={cat.isFeatured}
                  customClasses={{
                    ...customClassesForCategoryTile,
                    title: styles.title,
                  }}
                  linkObj={cat.categoryUrl}
                  tileLayout={tileLayout}
                />
              );
            })
          : null}
      </div>
    </div>
  );
};

export default CategoriesSectionGrid;
